import { useEffect, useRef } from 'react';
import { Link, useSearchParams } from 'react-router';
import { Alert } from '@/components/ui/Alert';
import { describeError, useConfirmEmailChange } from '../api';

/**
 * Completes an email change. Lands here from the link sent to the NEW address.
 *
 * A page rather than a dialog, and anonymous: the link is usually opened in
 * whichever browser the new inbox is signed into, which may have no session at
 * all. The token is the whole payload.
 */
export function ConfirmEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const confirm = useConfirmEmailChange();
  const attempted = useRef(false);

  useEffect(() => {
    // Tokens are single-use, and StrictMode runs effects twice in development.
    // Without this guard the second run always reports "already used".
    if (!token || attempted.current) {
      return;
    }

    attempted.current = true;
    confirm.mutate(token);
  }, [token, confirm]);

  return (
    <div className="status-page text-center">
      <img src="/gee-logo.png" alt="" width={881} height={519} className="status-page-mark" />
      <h1 className="text-2xl font-semibold tracking-tight text-surface-50">E-posta değişikliği</h1>

      <div className="mt-6">
        {!token ? (
          <Alert tone="error">Bu bağlantıda onay kodu yok.</Alert>
        ) : confirm.isPending ? (
          <p className="text-surface-400" role="status">
            Onaylanıyor…
          </p>
        ) : confirm.isSuccess ? (
          <Alert tone="success">
            Yeni e-posta adresin onaylandı. Bundan sonra bu adresle giriş yapacaksın.
          </Alert>
        ) : confirm.isError ? (
          <Alert tone="error">{describeError(confirm.error)}</Alert>
        ) : null}
      </div>

      <Link to="/profile" className="gf-button gf-button-primary mt-8">
        Profilime git
      </Link>
    </div>
  );
}
